(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('TypeIbqDetailController', TypeIbqDetailController);

    TypeIbqDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Type'];

    function TypeIbqDetailController($scope, $rootScope, $stateParams, previousState, entity, Type) {
        var vm = this;

        vm.type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('virtuallibraryApp:typeUpdate', function(event, result) {
            vm.type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
